module.exports = __webpack_public_path__ + "img/年货礼包2.68fabeb5.jpg";